module.exports = __webpack_public_path__ + "assets/img/live16_app.07c377a2.png";